<template>
  <div class="d-flex align-items-center" style="width: 100%; gap: 0.675rem">
    <div style="max-width: 10.5rem; min-width: 7rem; width: 100%">
      <v-select
        :value="statusFilter"
        :options="statusOptions"
        class="drop-shadow-default"
        :reduce="(val) => val.value"
        @input="(val) => $emit('update:statusFilter', val)"
        :placeholder="'Status'"
      />
    </div>
    <div v-if="$can('student.profile.identity')" style="max-width: 13rem; min-width: 13rem; width: 100%">
      <v-select
        :value="verificationFilter"
        :options="verificationOptions"
        class="drop-shadow-default"
        :reduce="(val) => val.value"
        @input="(val) => $emit('update:verificationFilter', val)"
        :placeholder="'Verification'"
      />
    </div>
    <div v-if="$can('student.profile.dera')" style="max-width: 10.5rem; min-width: 7rem; width: 100%">
      <v-select
        :value="deraStatusFilter"
        :options="deraStatusOptions"
        class="drop-shadow-default"
        :reduce="(val) => val.value"
        @input="(val) => $emit('update:deraStatusFilter', val)"
        :placeholder="'DERA'"
      />
    </div>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BCardText } from 'bootstrap-vue';
import vSelect from 'vue-select';
import BCardActions from '@core/components/b-card-actions/BCardActions.vue';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BCardActions,
    BCardText,
    vSelect,
  },
  props: {
    statusFilter: {
      type: [String, null],
      default: null,
    },
    verificationFilter: {
      type: [String, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    verificationFilter: {
      type: [String, null],
      default: null,
    },
    verificationOptions: {
      type: Array,
      required: true,
    },
    deraStatusFilter: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {
      deraStatusOptions: [
        { label: 'Not sent', value: 'not_sent' },
        { label: 'Invited', value: 'invited' },
        { label: 'Started', value: 'started' },
        { label: 'Failed', value: 'failed' },
        { label: 'Passed', value: 'passed' },
      ],
    };
  },
};
</script>
